import React from 'react';
import {
  Checkbox,
  CheckboxGroup,
} from 'anf-core-react';
import { TmntHtml } from '../../Common';
import { MarketingBrandsPropTypes, MarketingBrandsDefaultProps } from './props';
import LegalText from './LegalText';

/**
 * Marketing preferences component for brand selection
 * Renders a checkbox group allowing users to opt-in to marketing communications from various brands
 *
 * @param {Object} props - Component properties
 * @param {Object} props.marketingBrandsGroup - Configuration object containing brand options and labels
 * @param {Function} props.isMarketingBrandChecked - Function to check if a brand is currently selected
 * @param {Function} props.handleMarketingBrandsChange - Callback for brand selection changes
 * @param {Object} props.marketingBrandsField - React Hook Form field object for form integration
 * @returns {JSX.Element} Marketing brands checkbox group
 */
function MarketingBrands({
  marketingBrandsGroup,
  isMarketingBrandChecked,
  handleMarketingBrandsChange,
  marketingBrandsField,
}) {
  const renderCheckboxGroup = (group = []) => {
    if (!group.length) return null;

    const { label, description, optionList } = group[0];

    const renderCheckboxDescription = ({ desc, title }) => (
      <>
        {/* TODO: Will require SCSS to display: block the bottom span for the legal text */}
        <LegalText text={title} />
        { desc && <TmntHtml tmnt={desc} /> }
      </>
    );

    const checkboxes = optionList.map((item) => {
      const id = `signInMarketingPreferencesCheckbox_${item.optionValue}`;

      return (
        <Checkbox
          description={renderCheckboxDescription({ desc: item?.description, title: item.text })}
          key={id}
          id={id}
          label={item.text?.value}
          isChecked={isMarketingBrandChecked(item.optionValue)}
          onChange={handleMarketingBrandsChange}
          name={marketingBrandsField.name}
          value={item.optionValue}
        />
      );
    });

    return (
      <CheckboxGroup title={label?.value}>
        <span className={description?.key}>
          { description?.value }
        </span>
        { checkboxes }
      </CheckboxGroup>
    );
  };

  return renderCheckboxGroup(marketingBrandsGroup.fieldList);
}

MarketingBrands.propTypes = MarketingBrandsPropTypes;
MarketingBrands.defaultProps = MarketingBrandsDefaultProps;

export default MarketingBrands;
